export const actionTypes = {
  GET_LOAN_ELIGIBILITY_LOG_START: 'GET_LOAN_ELIGIBILITY_LOG_START',
  GET_LOAN_ELIGIBILITY_LOG_SUCCESS: 'GET_LOAN_ELIGIBILITY_LOG_SUCCESS',
  GET_LOAN_ELIGIBILITY_LOG_FINISH: 'GET_LOAN_ELIGIBILITY_LOG_FINISH',
}
